import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../../service/udnick';

export const editarTransportadoraServices = {
  alterarTransportadoraSolicitacaoRetorno: (
    nuNota: number,
    codTransportadora: number | undefined,
    clienteRetira: boolean
  ): Promise<AxiosResponse> =>
    UDNICK.callService('alterarTransportadoraSolicitacaoRetorno', {
      nuNota,
      codTransportadora,
      clienteRetira,
    }),
};
